import * as React from 'react'

import {
  City,
  FirstName,
  FormGroup,
  LastName,
  MultipleAddressLine,
  PostalCode,
  Region,
} from '@grandvisionhq/forms'
import { useIntl } from '@grandvisionhq/state'

import { isPostalCode, isValidStreetInfo, isValidStreetName } from '../../util/form-validation'
import { FormProps } from './types'

const streetValidations = [isValidStreetName]

const addressValidations = [isValidStreetInfo]

const AddressForm: React.FC<FormProps> = () => {
  const { getLabel } = useIntl()

  return (
    <React.Fragment>
      <FormGroup columns={2}>
        <FirstName
          label={getLabel('checkout.contact.firstName')}
          errorMessage={getLabel('checkout.contact.firstName.errorMessage')}
          maxLength={13}
        />
        <LastName
          label={getLabel('checkout.contact.lastName')}
          errorMessage={getLabel('checkout.contact.lastName.errorMessage')}
          maxLength={22}
        />
      </FormGroup>
      <FormGroup>
        <MultipleAddressLine
          streetValidations={streetValidations}
          validations={addressValidations}
          label={getLabel('checkout.address.addressLine')}
          errorMessage={getLabel('checkout.address.addressLine.errorMessage')}
          addLineLabel={getLabel('checkout.address.addressLine.addAddressLine')}
          lineTwoLabel={getLabel('checkout.address.addressLineTwo')}
          shouldCombineAddress
          maxLength={32}
          initialLineAmount={2}
          disableAddLineThree
        />
      </FormGroup>
      <FormGroup columns={2}>
        <City
          label={getLabel('checkout.address.city')}
          errorMessage={getLabel('checkout.address.city.errorMessage')}
          maxLength={32}
        />
        <PostalCode
          label={getLabel('checkout.address.postalCode')}
          validations={[isPostalCode]}
          errorMessage={getLabel('checkout.address.postalCode.errorMessage')}
        />
      </FormGroup>
      <FormGroup>
        <Region
          label={getLabel('checkout.address.district')}
          errorMessage={getLabel('checkout.address.district.errorMessage')}
          maxLength={32}
        />
      </FormGroup>
    </React.Fragment>
  )
}

export const CheckoutAddressForm = () => <AddressForm />

export default AddressForm
